import { useLocation } from "react-router-dom";
import { useGracePeriodBanner } from "../hooks/useGracePeriodBanner";
import { ehTelaDeEntrada } from "../utils/telasDeEntrada";
import { useMaintenanceContext } from "@/contexts/MaintenanceContext";
import { MaintenanceBanner } from "./MaintenanceBanner";
import { MaintenanceWarningModal } from "./MaintenanceWarningModal";
import { PostMaintenanceBanner } from "./PostMaintenanceBanner";
import { RestoredDraftIndicator } from "./RestoredDraftIndicator";
import { DraftPersistentBadge } from "./DraftPersistentBadge";

export const MaintenanceOverlay: React.FC = () => {
  const {
    phase,
    gracePeriodEndsAt,
    autoSaveStatus,
    message,
    estimatedEnd,
    modalOpen,
    onModalOpenChange,
    onPhaseChange,
    onComplete,
    carenciaEmCurso,
  } = useGracePeriodBanner();

  const { showReturnBanner, hasDraft } = useMaintenanceContext();
  // Nas telas de entrada o aviso grande do login fala da manutenção; a faixa
  // e o diálogo da carência são de quem está logado (ver telasDeEntrada.ts).
  const naTelaDeEntrada = ehTelaDeEntrada(useLocation().pathname);

  return (
    <>
      {/* Story 3.7: Post-maintenance return banner + draft indicator */}
      <PostMaintenanceBanner />
      <RestoredDraftIndicator />

      {/* Story 3.7 Task 4: Persistent badge when banner dismissed but draft exists */}
      {!showReturnBanner && hasDraft && <DraftPersistentBadge />}

      {/* Grace period banner — só enquanto a carência está DE VERDADE em
          curso (achado MÉDIO, E2E 28/09/2026, item 7): fase válida (nunca
          "expired") e gracePeriodEndsAt no futuro — ver carenciaEmCurso em
          useGracePeriodBanner.ts. */}
      {!naTelaDeEntrada && carenciaEmCurso && phase && gracePeriodEndsAt && (
        <>
          <MaintenanceBanner
            phase={phase}
            autoSaveStatus={autoSaveStatus}
            gracePeriodEndsAt={gracePeriodEndsAt}
            onPhaseChange={onPhaseChange}
            onComplete={onComplete}
          />
          <MaintenanceWarningModal
            open={modalOpen}
            onOpenChange={onModalOpenChange}
            message={message ?? "O sistema entrará em manutenção em breve."}
            estimatedEnd={estimatedEnd}
            autoSaveEnabled={true}
          />
        </>
      )}
    </>
  );
};
